import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useProductMetadata } from '@/components/LayoutWithMenu/productMetadataHooks'
import { SelectInsuranceGrid } from '@/components/SelectInsuranceGrid/SelectInsuranceGrid'
import { isSameLink } from '@/utils/url'
import { Button } from 'ui/src/components/Button/Button'
import { Dialog } from 'ui/src/components/Dialog/Dialog'
import { FullscreenDialog } from 'ui/src/components/Dialog/FullscreenDialog'
import { visuallyHidden } from 'ui/src/utils/visibility.css'
import { selectInsuranceGrid } from './ProductGridItem.css'

type Props = {
  url: string
}

export const ProductGridItemBlockCategoryCTA = ({ url }: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  const products = useProductMetadata()
  const { t } = useTranslation('common')

  const productsByCategory = (products ?? []).filter(
    (product) => product.categoryPageLink && isSameLink(product.categoryPageLink, url),
  )

  if (productsByCategory.length < 1) {
    console.warn(`[ProductGridItem]: No products category link ${url} were found. Skipping cta render!`)
    return null
  }

  return (
    <Dialog.Root open={isOpen} onOpenChange={setIsOpen}>
      <Dialog.Trigger asChild>
        <Button variant="primary-alt" size="medium">
          {t('GET_PRICE_LINK')}
        </Button>
      </Dialog.Trigger>

      <FullscreenDialog.Modal accessibleCloseLabel={t('DIALOG_CLOSE')}>
        <Dialog.Title className={visuallyHidden}>{t('SELECT_INSURANCE')}</Dialog.Title>
        <SelectInsuranceGrid
          products={productsByCategory}
          heading={t('SELECT_INSURANCE')}
          className={selectInsuranceGrid}
        />
      </FullscreenDialog.Modal>
    </Dialog.Root>
  )
}
